import { Text } from "@flat-ui";
import { Box } from "@mui/material";

/** Renders the tooltip for the HoloBuilder sidebar item */
export function NewCreditTooltip(): JSX.Element {
  return (
    <Box
      sx={{
        padding: "12px",
      }}
    >
      <Text
        dark
        variant="heading12"
        textTransform="uppercase"
        marginBottom="10px"
        display="block"
      >
        Balance not updated yet.
      </Text>
      <Text dark variant="bodyS">
        Your purchased tokens will be available shortly.
      </Text>
    </Box>
  );
}
